export enum Country {
  /**
   * Andorra
   */
  Andorra = "AD",
  /**
   * United Arab Emirates (the)
   */
  UnitedArabEmirates = "AE",
  /**
   * Afghanistan
   */
  Afghanistan = "AF",
  /**
   * Antigua and Barbuda
   */
  AntiguaAndBarbuda = "AG",
  /**
   * Anguilla
   */
  Anguilla = "AI",
  /**
   * Albania
   */
  Albania = "AL",
  /**
   * Armenia
   */
  Armenia = "AM",
  /**
   * Angola
   */
  Angola = "AO",
  /**
   * Antarctica
   */
  Antarctica = "AQ",
  /**
   * Argentina
   */
  Argentina = "AR",
  /**
   * American Samoa
   */
  AmericanSamoa = "AS",
  /**
   * Austria
   */
  Austria = "AT",
  /**
   * Australia
   */
  Australia = "AU",
  /**
   * Aruba
   */
  Aruba = "AW",
  /**
   * Åland Islands
   */
  ÅlandIslands = "AX",
  /**
   * Azerbaijan
   */
  Azerbaijan = "AZ",
  /**
   * Bosnia and Herzegovina
   */
  BosniaAndHerzegovina = "BA",
  /**
   * Barbados
   */
  Barbados = "BB",
  /**
   * Bangladesh
   */
  Bangladesh = "BD",
  /**
   * Belgium
   */
  Belgium = "BE",
  /**
   * Burkina Faso
   */
  BurkinaFaso = "BF",
  /**
   * Bulgaria
   */
  Bulgaria = "BG",
  /**
   * Bahrain
   */
  Bahrain = "BH",
  /**
   * Burundi
   */
  Burundi = "BI",
  /**
   * Benin
   */
  Benin = "BJ",
  /**
   * Saint Barthélemy
   */
  SaintBarthélemy = "BL",
  /**
   * Bermuda
   */
  Bermuda = "BM",
  /**
   * Brunei Darussalam
   */
  BruneiDarussalam = "BN",
  /**
   * Bolivia (Plurinational State of)
   */
  BoliviaPlurinationalState = "BO",
  /**
   * Bonaire, Sint Eustatius and Saba
   */
  BonaireSintEustatiusAndSaba = "BQ",
  /**
   * Brazil
   */
  Brazil = "BR",
  /**
   * Bahamas (the)
   */
  Bahamas = "BS",
  /**
   * Bhutan
   */
  Bhutan = "BT",
  /**
   * Bouvet Island
   */
  BouvetIsland = "BV",
  /**
   * Botswana
   */
  Botswana = "BW",
  /**
   * Belarus
   */
  Belarus = "BY",
  /**
   * Belize
   */
  Belize = "BZ",
  /**
   * Canada
   */
  Canada = "CA",
  /**
   * Cocos (Keeling) Islands (the)
   */
  CocosKeelingIslands = "CC",
  /**
   * Congo (the Democratic Republic of the)
   */
  CongoDemocraticRepublic = "CD",
  /**
   * Central African Republic (the)
   */
  CentralAfricanRepublic = "CF",
  /**
   * Congo (the)
   */
  Congo = "CG",
  /**
   * Switzerland
   */
  Switzerland = "CH",
  /**
   * Côte d'Ivoire
   */
  CôteDivoire = "CI",
  /**
   * Cook Islands (the)
   */
  CookIslands = "CK",
  /**
   * Chile
   */
  Chile = "CL",
  /**
   * Cameroon
   */
  Cameroon = "CM",
  /**
   * China
   */
  China = "CN",
  /**
   * Colombia
   */
  Colombia = "CO",
  /**
   * Costa Rica
   */
  CostaRica = "CR",
  /**
   * Cuba
   */
  Cuba = "CU",
  /**
   * Cabo Verde
   */
  CaboVerde = "CV",
  /**
   * Curaçao
   */
  Curaçao = "CW",
  /**
   * Christmas Island
   */
  ChristmasIsland = "CX",
  /**
   * Cyprus
   */
  Cyprus = "CY",
  /**
   * Czechia
   */
  Czechia = "CZ",
  /**
   * Germany
   */
  Germany = "DE",
  /**
   * Djibouti
   */
  Djibouti = "DJ",
  /**
   * Denmark
   */
  Denmark = "DK",
  /**
   * Dominica
   */
  Dominica = "DM",
  /**
   * Dominican Republic (the)
   */
  DominicanRepublic = "DO",
  /**
   * Algeria
   */
  Algeria = "DZ",
  /**
   * Ecuador
   */
  Ecuador = "EC",
  /**
   * Estonia
   */
  Estonia = "EE",
  /**
   * Egypt
   */
  Egypt = "EG",
  /**
   * Western Sahara*
   */
  WesternSahara = "EH",
  /**
   * Eritrea
   */
  Eritrea = "ER",
  /**
   * Spain
   */
  Spain = "ES",
  /**
   * Ethiopia
   */
  Ethiopia = "ET",
  /**
   * Finland
   */
  Finland = "FI",
  /**
   * Fiji
   */
  Fiji = "FJ",
  /**
   * Falkland Islands (the) [Malvinas]
   */
  FalklandIslandsMalvinas = "FK",
  /**
   * Micronesia (Federated States of)
   */
  MicronesiaFederatedStates = "FM",
  /**
   * Faroe Islands (the)
   */
  FaroeIslands = "FO",
  /**
   * France
   */
  France = "FR",
  /**
   * Gabon
   */
  Gabon = "GA",
  /**
   * United Kingdom of Great Britain and Northern Ireland (the)
   */
  UnitedKingdomGreatBritainAndNorthernIreland = "GB",
  /**
   * Grenada
   */
  Grenada = "GD",
  /**
   * Georgia
   */
  Georgia = "GE",
  /**
   * French Guiana
   */
  FrenchGuiana = "GF",
  /**
   * Guernsey
   */
  Guernsey = "GG",
  /**
   * Ghana
   */
  Ghana = "GH",
  /**
   * Gibraltar
   */
  Gibraltar = "GI",
  /**
   * Greenland
   */
  Greenland = "GL",
  /**
   * Gambia (the)
   */
  Gambia = "GM",
  /**
   * Guinea
   */
  Guinea = "GN",
  /**
   * Guadeloupe
   */
  Guadeloupe = "GP",
  /**
   * Equatorial Guinea
   */
  EquatorialGuinea = "GQ",
  /**
   * Greece
   */
  Greece = "GR",
  /**
   * South Georgia and the South Sandwich Islands
   */
  SouthGeorgiaAndSouthSandwichIslands = "GS",
  /**
   * Guatemala
   */
  Guatemala = "GT",
  /**
   * Guam
   */
  Guam = "GU",
  /**
   * Guinea-Bissau
   */
  GuineaBissau = "GW",
  /**
   * Guyana
   */
  Guyana = "GY",
  /**
   * Hong Kong
   */
  HongKong = "HK",
  /**
   * Heard Island and McDonald Islands
   */
  HeardIslandAndMcdonaldIslands = "HM",
  /**
   * Honduras
   */
  Honduras = "HN",
  /**
   * Croatia
   */
  Croatia = "HR",
  /**
   * Haiti
   */
  Haiti = "HT",
  /**
   * Hungary
   */
  Hungary = "HU",
  /**
   * Indonesia
   */
  Indonesia = "ID",
  /**
   * Ireland
   */
  Ireland = "IE",
  /**
   * Israel
   */
  Israel = "IL",
  /**
   * Isle of Man
   */
  IsleMan = "IM",
  /**
   * India
   */
  India = "IN",
  /**
   * British Indian Ocean Territory (the)
   */
  BritishIndianOceanTerritory = "IO",
  /**
   * Iraq
   */
  Iraq = "IQ",
  /**
   * Iran (Islamic Republic of)
   */
  IranIslamicRepublic = "IR",
  /**
   * Iceland
   */
  Iceland = "IS",
  /**
   * Italy
   */
  Italy = "IT",
  /**
   * Jersey
   */
  Jersey = "JE",
  /**
   * Jamaica
   */
  Jamaica = "JM",
  /**
   * Jordan
   */
  Jordan = "JO",
  /**
   * Japan
   */
  Japan = "JP",
  /**
   * Kenya
   */
  Kenya = "KE",
  /**
   * Kyrgyzstan
   */
  Kyrgyzstan = "KG",
  /**
   * Cambodia
   */
  Cambodia = "KH",
  /**
   * Kiribati
   */
  Kiribati = "KI",
  /**
   * Comoros (the)
   */
  Comoros = "KM",
  /**
   * Saint Kitts and Nevis
   */
  SaintKittsAndNevis = "KN",
  /**
   * Korea (the Democratic People's Republic of)
   */
  KoreaDemocraticPeoplesRepublic = "KP",
  /**
   * Korea (the Republic of)
   */
  KoreaRepublic = "KR",
  /**
   * Kuwait
   */
  Kuwait = "KW",
  /**
   * Cayman Islands (the)
   */
  CaymanIslands = "KY",
  /**
   * Kazakhstan
   */
  Kazakhstan = "KZ",
  /**
   * Lao People's Democratic Republic (the)
   */
  LaoPeoplesDemocraticRepublic = "LA",
  /**
   * Lebanon
   */
  Lebanon = "LB",
  /**
   * Saint Lucia
   */
  SaintLucia = "LC",
  /**
   * Liechtenstein
   */
  Liechtenstein = "LI",
  /**
   * Sri Lanka
   */
  SriLanka = "LK",
  /**
   * Liberia
   */
  Liberia = "LR",
  /**
   * Lesotho
   */
  Lesotho = "LS",
  /**
   * Lithuania
   */
  Lithuania = "LT",
  /**
   * Luxembourg
   */
  Luxembourg = "LU",
  /**
   * Latvia
   */
  Latvia = "LV",
  /**
   * Libya
   */
  Libya = "LY",
  /**
   * Morocco
   */
  Morocco = "MA",
  /**
   * Monaco
   */
  Monaco = "MC",
  /**
   * Moldova (the Republic of)
   */
  MoldovaRepublic = "MD",
  /**
   * Montenegro
   */
  Montenegro = "ME",
  /**
   * Saint Martin (French part)
   */
  SaintMartinFrenchPart = "MF",
  /**
   * Madagascar
   */
  Madagascar = "MG",
  /**
   * Marshall Islands (the)
   */
  MarshallIslands = "MH",
  /**
   * North Macedonia
   */
  NorthMacedonia = "MK",
  /**
   * Mali
   */
  Mali = "ML",
  /**
   * Myanmar
   */
  Myanmar = "MM",
  /**
   * Mongolia
   */
  Mongolia = "MN",
  /**
   * Macao
   */
  Macao = "MO",
  /**
   * Northern Mariana Islands (the)
   */
  NorthernMarianaIslands = "MP",
  /**
   * Martinique
   */
  Martinique = "MQ",
  /**
   * Mauritania
   */
  Mauritania = "MR",
  /**
   * Montserrat
   */
  Montserrat = "MS",
  /**
   * Malta
   */
  Malta = "MT",
  /**
   * Mauritius
   */
  Mauritius = "MU",
  /**
   * Maldives
   */
  Maldives = "MV",
  /**
   * Malawi
   */
  Malawi = "MW",
  /**
   * Mexico
   */
  Mexico = "MX",
  /**
   * Malaysia
   */
  Malaysia = "MY",
  /**
   * Mozambique
   */
  Mozambique = "MZ",
  /**
   * Namibia
   */
  Namibia = "NA",
  /**
   * New Caledonia
   */
  NewCaledonia = "NC",
  /**
   * Niger (the)
   */
  Niger = "NE",
  /**
   * Norfolk Island
   */
  NorfolkIsland = "NF",
  /**
   * Nigeria
   */
  Nigeria = "NG",
  /**
   * Nicaragua
   */
  Nicaragua = "NI",
  /**
   * Netherlands (the)
   */
  Netherlands = "NL",
  /**
   * Norway
   */
  Norway = "NO",
  /**
   * Nepal
   */
  Nepal = "NP",
  /**
   * Nauru
   */
  Nauru = "NR",
  /**
   * Niue
   */
  Niue = "NU",
  /**
   * New Zealand
   */
  NewZealand = "NZ",
  /**
   * Oman
   */
  Oman = "OM",
  /**
   * Panama
   */
  Panama = "PA",
  /**
   * Peru
   */
  Peru = "PE",
  /**
   * French Polynesia
   */
  FrenchPolynesia = "PF",
  /**
   * Papua New Guinea
   */
  PapuaNewGuinea = "PG",
  /**
   * Philippines (the)
   */
  Philippines = "PH",
  /**
   * Pakistan
   */
  Pakistan = "PK",
  /**
   * Poland
   */
  Poland = "PL",
  /**
   * Saint Pierre and Miquelon
   */
  SaintPierreAndMiquelon = "PM",
  /**
   * Pitcairn
   */
  Pitcairn = "PN",
  /**
   * Puerto Rico
   */
  PuertoRico = "PR",
  /**
   * Palestine, State of
   */
  PalestineState = "PS",
  /**
   * Portugal
   */
  Portugal = "PT",
  /**
   * Palau
   */
  Palau = "PW",
  /**
   * Paraguay
   */
  Paraguay = "PY",
  /**
   * Qatar
   */
  Qatar = "QA",
  /**
   * Réunion
   */
  Réunion = "RE",
  /**
   * Romania
   */
  Romania = "RO",
  /**
   * Serbia
   */
  Serbia = "RS",
  /**
   * Russian Federation (the)
   */
  RussianFederation = "RU",
  /**
   * Rwanda
   */
  Rwanda = "RW",
  /**
   * Saudi Arabia
   */
  SaudiArabia = "SA",
  /**
   * Solomon Islands
   */
  SolomonIslands = "SB",
  /**
   * Seychelles
   */
  Seychelles = "SC",
  /**
   * Sudan (the)
   */
  Sudan = "SD",
  /**
   * Sweden
   */
  Sweden = "SE",
  /**
   * Singapore
   */
  Singapore = "SG",
  /**
   * Saint Helena, Ascension and Tristan da Cunha
   */
  SaintHelenaAscensionAndTristanDaCunha = "SH",
  /**
   * Slovenia
   */
  Slovenia = "SI",
  /**
   * Svalbard and Jan Mayen
   */
  SvalbardAndJanMayen = "SJ",
  /**
   * Slovakia
   */
  Slovakia = "SK",
  /**
   * Sierra Leone
   */
  SierraLeone = "SL",
  /**
   * San Marino
   */
  SanMarino = "SM",
  /**
   * Senegal
   */
  Senegal = "SN",
  /**
   * Somalia
   */
  Somalia = "SO",
  /**
   * Suriname
   */
  Suriname = "SR",
  /**
   * South Sudan
   */
  SouthSudan = "SS",
  /**
   * Sao Tome and Principe
   */
  SaoTomeAndPrincipe = "ST",
  /**
   * El Salvador
   */
  ElSalvador = "SV",
  /**
   * Sint Maarten (Dutch part)
   */
  SintMaartenDutchPart = "SX",
  /**
   * Syrian Arab Republic (the)
   */
  SyrianArabRepublic = "SY",
  /**
   * Eswatini
   */
  Eswatini = "SZ",
  /**
   * Turks and Caicos Islands (the)
   */
  TurksAndCaicosIslands = "TC",
  /**
   * Chad
   */
  Chad = "TD",
  /**
   * French Southern Territories (the)
   */
  FrenchSouthernTerritories = "TF",
  /**
   * Togo
   */
  Togo = "TG",
  /**
   * Thailand
   */
  Thailand = "TH",
  /**
   * Tajikistan
   */
  Tajikistan = "TJ",
  /**
   * Tokelau
   */
  Tokelau = "TK",
  /**
   * Timor-Leste
   */
  TimorLeste = "TL",
  /**
   * Turkmenistan
   */
  Turkmenistan = "TM",
  /**
   * Tunisia
   */
  Tunisia = "TN",
  /**
   * Tonga
   */
  Tonga = "TO",
  /**
   * Türkiye
   */
  Türkiye = "TR",
  /**
   * Trinidad and Tobago
   */
  TrinidadAndTobago = "TT",
  /**
   * Tuvalu
   */
  Tuvalu = "TV",
  /**
   * Taiwan (Province of China)
   */
  TaiwanProvinceChina = "TW",
  /**
   * Tanzania, the United Republic of
   */
  TanzaniaUnitedRepublic = "TZ",
  /**
   * Ukraine
   */
  Ukraine = "UA",
  /**
   * Uganda
   */
  Uganda = "UG",
  /**
   * United States Minor Outlying Islands (the)
   */
  UnitedStatesMinorOutlyingIslands = "UM",
  /**
   * United States of America (the)
   */
  UnitedStatesAmerica = "US",
  /**
   * Uruguay
   */
  Uruguay = "UY",
  /**
   * Uzbekistan
   */
  Uzbekistan = "UZ",
  /**
   * Holy See (the)
   */
  HolySee = "VA",
  /**
   * Saint Vincent and the Grenadines
   */
  SaintVincentAndGrenadines = "VC",
  /**
   * Venezuela (Bolivarian Republic of)
   */
  VenezuelaBolivarianRepublic = "VE",
  /**
   * Virgin Islands (British)
   */
  VirginIslandsBritish = "VG",
  /**
   * Virgin Islands (U.S.)
   */
  VirginIslandsUS = "VI",
  /**
   * Viet Nam
   */
  VietNam = "VN",
  /**
   * Vanuatu
   */
  Vanuatu = "VU",
  /**
   * Wallis and Futuna
   */
  WallisAndFutuna = "WF",
  /**
   * Samoa
   */
  Samoa = "WS",
  /**
   * Yemen
   */
  Yemen = "YE",
  /**
   * Mayotte
   */
  Mayotte = "YT",
  /**
   * South Africa
   */
  SouthAfrica = "ZA",
  /**
   * Zambia
   */
  Zambia = "ZM",
  /**
   * Zimbabwe
   */
  Zimbabwe = "ZW",
  /**
   * Kosovo
   */
  Kosovo = "1A",
  /**
   * United Kingdom (Northern Ireland)
   */
  UnitedKingdomNorthernIreland = "XI",
}

export function description(value: Country): string {
  switch (value) {
    case Country.Andorra:
      return "Andorra";
    case Country.UnitedArabEmirates:
      return "United Arab Emirates (the)";
    case Country.Afghanistan:
      return "Afghanistan";
    case Country.AntiguaAndBarbuda:
      return "Antigua and Barbuda";
    case Country.Anguilla:
      return "Anguilla";
    case Country.Albania:
      return "Albania";
    case Country.Armenia:
      return "Armenia";
    case Country.Angola:
      return "Angola";
    case Country.Antarctica:
      return "Antarctica";
    case Country.Argentina:
      return "Argentina";
    case Country.AmericanSamoa:
      return "American Samoa";
    case Country.Austria:
      return "Austria";
    case Country.Australia:
      return "Australia";
    case Country.Aruba:
      return "Aruba";
    case Country.ÅlandIslands:
      return "Åland Islands";
    case Country.Azerbaijan:
      return "Azerbaijan";
    case Country.BosniaAndHerzegovina:
      return "Bosnia and Herzegovina";
    case Country.Barbados:
      return "Barbados";
    case Country.Bangladesh:
      return "Bangladesh";
    case Country.Belgium:
      return "Belgium";
    case Country.BurkinaFaso:
      return "Burkina Faso";
    case Country.Bulgaria:
      return "Bulgaria";
    case Country.Bahrain:
      return "Bahrain";
    case Country.Burundi:
      return "Burundi";
    case Country.Benin:
      return "Benin";
    case Country.SaintBarthélemy:
      return "Saint Barthélemy";
    case Country.Bermuda:
      return "Bermuda";
    case Country.BruneiDarussalam:
      return "Brunei Darussalam";
    case Country.BoliviaPlurinationalState:
      return "Bolivia (Plurinational State of)";
    case Country.BonaireSintEustatiusAndSaba:
      return "Bonaire, Sint Eustatius and Saba";
    case Country.Brazil:
      return "Brazil";
    case Country.Bahamas:
      return "Bahamas (the)";
    case Country.Bhutan:
      return "Bhutan";
    case Country.BouvetIsland:
      return "Bouvet Island";
    case Country.Botswana:
      return "Botswana";
    case Country.Belarus:
      return "Belarus";
    case Country.Belize:
      return "Belize";
    case Country.Canada:
      return "Canada";
    case Country.CocosKeelingIslands:
      return "Cocos (Keeling) Islands (the)";
    case Country.CongoDemocraticRepublic:
      return "Congo (the Democratic Republic of the)";
    case Country.CentralAfricanRepublic:
      return "Central African Republic (the)";
    case Country.Congo:
      return "Congo (the)";
    case Country.Switzerland:
      return "Switzerland";
    case Country.CôteDivoire:
      return "Côte d'Ivoire";
    case Country.CookIslands:
      return "Cook Islands (the)";
    case Country.Chile:
      return "Chile";
    case Country.Cameroon:
      return "Cameroon";
    case Country.China:
      return "China";
    case Country.Colombia:
      return "Colombia";
    case Country.CostaRica:
      return "Costa Rica";
    case Country.Cuba:
      return "Cuba";
    case Country.CaboVerde:
      return "Cabo Verde";
    case Country.Curaçao:
      return "Curaçao";
    case Country.ChristmasIsland:
      return "Christmas Island";
    case Country.Cyprus:
      return "Cyprus";
    case Country.Czechia:
      return "Czechia";
    case Country.Germany:
      return "Germany";
    case Country.Djibouti:
      return "Djibouti";
    case Country.Denmark:
      return "Denmark";
    case Country.Dominica:
      return "Dominica";
    case Country.DominicanRepublic:
      return "Dominican Republic (the)";
    case Country.Algeria:
      return "Algeria";
    case Country.Ecuador:
      return "Ecuador";
    case Country.Estonia:
      return "Estonia";
    case Country.Egypt:
      return "Egypt";
    case Country.WesternSahara:
      return "Western Sahara*";
    case Country.Eritrea:
      return "Eritrea";
    case Country.Spain:
      return "Spain";
    case Country.Ethiopia:
      return "Ethiopia";
    case Country.Finland:
      return "Finland";
    case Country.Fiji:
      return "Fiji";
    case Country.FalklandIslandsMalvinas:
      return "Falkland Islands (the) [Malvinas]";
    case Country.MicronesiaFederatedStates:
      return "Micronesia (Federated States of)";
    case Country.FaroeIslands:
      return "Faroe Islands (the)";
    case Country.France:
      return "France";
    case Country.Gabon:
      return "Gabon";
    case Country.UnitedKingdomGreatBritainAndNorthernIreland:
      return "United Kingdom of Great Britain and Northern Ireland (the)";
    case Country.Grenada:
      return "Grenada";
    case Country.Georgia:
      return "Georgia";
    case Country.FrenchGuiana:
      return "French Guiana";
    case Country.Guernsey:
      return "Guernsey";
    case Country.Ghana:
      return "Ghana";
    case Country.Gibraltar:
      return "Gibraltar";
    case Country.Greenland:
      return "Greenland";
    case Country.Gambia:
      return "Gambia (the)";
    case Country.Guinea:
      return "Guinea";
    case Country.Guadeloupe:
      return "Guadeloupe";
    case Country.EquatorialGuinea:
      return "Equatorial Guinea";
    case Country.Greece:
      return "Greece";
    case Country.SouthGeorgiaAndSouthSandwichIslands:
      return "South Georgia and the South Sandwich Islands";
    case Country.Guatemala:
      return "Guatemala";
    case Country.Guam:
      return "Guam";
    case Country.GuineaBissau:
      return "Guinea-Bissau";
    case Country.Guyana:
      return "Guyana";
    case Country.HongKong:
      return "Hong Kong";
    case Country.HeardIslandAndMcdonaldIslands:
      return "Heard Island and McDonald Islands";
    case Country.Honduras:
      return "Honduras";
    case Country.Croatia:
      return "Croatia";
    case Country.Haiti:
      return "Haiti";
    case Country.Hungary:
      return "Hungary";
    case Country.Indonesia:
      return "Indonesia";
    case Country.Ireland:
      return "Ireland";
    case Country.Israel:
      return "Israel";
    case Country.IsleMan:
      return "Isle of Man";
    case Country.India:
      return "India";
    case Country.BritishIndianOceanTerritory:
      return "British Indian Ocean Territory (the)";
    case Country.Iraq:
      return "Iraq";
    case Country.IranIslamicRepublic:
      return "Iran (Islamic Republic of)";
    case Country.Iceland:
      return "Iceland";
    case Country.Italy:
      return "Italy";
    case Country.Jersey:
      return "Jersey";
    case Country.Jamaica:
      return "Jamaica";
    case Country.Jordan:
      return "Jordan";
    case Country.Japan:
      return "Japan";
    case Country.Kenya:
      return "Kenya";
    case Country.Kyrgyzstan:
      return "Kyrgyzstan";
    case Country.Cambodia:
      return "Cambodia";
    case Country.Kiribati:
      return "Kiribati";
    case Country.Comoros:
      return "Comoros (the)";
    case Country.SaintKittsAndNevis:
      return "Saint Kitts and Nevis";
    case Country.KoreaDemocraticPeoplesRepublic:
      return "Korea (the Democratic People's Republic of)";
    case Country.KoreaRepublic:
      return "Korea (the Republic of)";
    case Country.Kuwait:
      return "Kuwait";
    case Country.CaymanIslands:
      return "Cayman Islands (the)";
    case Country.Kazakhstan:
      return "Kazakhstan";
    case Country.LaoPeoplesDemocraticRepublic:
      return "Lao People's Democratic Republic (the)";
    case Country.Lebanon:
      return "Lebanon";
    case Country.SaintLucia:
      return "Saint Lucia";
    case Country.Liechtenstein:
      return "Liechtenstein";
    case Country.SriLanka:
      return "Sri Lanka";
    case Country.Liberia:
      return "Liberia";
    case Country.Lesotho:
      return "Lesotho";
    case Country.Lithuania:
      return "Lithuania";
    case Country.Luxembourg:
      return "Luxembourg";
    case Country.Latvia:
      return "Latvia";
    case Country.Libya:
      return "Libya";
    case Country.Morocco:
      return "Morocco";
    case Country.Monaco:
      return "Monaco";
    case Country.MoldovaRepublic:
      return "Moldova (the Republic of)";
    case Country.Montenegro:
      return "Montenegro";
    case Country.SaintMartinFrenchPart:
      return "Saint Martin (French part)";
    case Country.Madagascar:
      return "Madagascar";
    case Country.MarshallIslands:
      return "Marshall Islands (the)";
    case Country.NorthMacedonia:
      return "North Macedonia";
    case Country.Mali:
      return "Mali";
    case Country.Myanmar:
      return "Myanmar";
    case Country.Mongolia:
      return "Mongolia";
    case Country.Macao:
      return "Macao";
    case Country.NorthernMarianaIslands:
      return "Northern Mariana Islands (the)";
    case Country.Martinique:
      return "Martinique";
    case Country.Mauritania:
      return "Mauritania";
    case Country.Montserrat:
      return "Montserrat";
    case Country.Malta:
      return "Malta";
    case Country.Mauritius:
      return "Mauritius";
    case Country.Maldives:
      return "Maldives";
    case Country.Malawi:
      return "Malawi";
    case Country.Mexico:
      return "Mexico";
    case Country.Malaysia:
      return "Malaysia";
    case Country.Mozambique:
      return "Mozambique";
    case Country.Namibia:
      return "Namibia";
    case Country.NewCaledonia:
      return "New Caledonia";
    case Country.Niger:
      return "Niger (the)";
    case Country.NorfolkIsland:
      return "Norfolk Island";
    case Country.Nigeria:
      return "Nigeria";
    case Country.Nicaragua:
      return "Nicaragua";
    case Country.Netherlands:
      return "Netherlands (the)";
    case Country.Norway:
      return "Norway";
    case Country.Nepal:
      return "Nepal";
    case Country.Nauru:
      return "Nauru";
    case Country.Niue:
      return "Niue";
    case Country.NewZealand:
      return "New Zealand";
    case Country.Oman:
      return "Oman";
    case Country.Panama:
      return "Panama";
    case Country.Peru:
      return "Peru";
    case Country.FrenchPolynesia:
      return "French Polynesia";
    case Country.PapuaNewGuinea:
      return "Papua New Guinea";
    case Country.Philippines:
      return "Philippines (the)";
    case Country.Pakistan:
      return "Pakistan";
    case Country.Poland:
      return "Poland";
    case Country.SaintPierreAndMiquelon:
      return "Saint Pierre and Miquelon";
    case Country.Pitcairn:
      return "Pitcairn";
    case Country.PuertoRico:
      return "Puerto Rico";
    case Country.PalestineState:
      return "Palestine, State of";
    case Country.Portugal:
      return "Portugal";
    case Country.Palau:
      return "Palau";
    case Country.Paraguay:
      return "Paraguay";
    case Country.Qatar:
      return "Qatar";
    case Country.Réunion:
      return "Réunion";
    case Country.Romania:
      return "Romania";
    case Country.Serbia:
      return "Serbia";
    case Country.RussianFederation:
      return "Russian Federation (the)";
    case Country.Rwanda:
      return "Rwanda";
    case Country.SaudiArabia:
      return "Saudi Arabia";
    case Country.SolomonIslands:
      return "Solomon Islands";
    case Country.Seychelles:
      return "Seychelles";
    case Country.Sudan:
      return "Sudan (the)";
    case Country.Sweden:
      return "Sweden";
    case Country.Singapore:
      return "Singapore";
    case Country.SaintHelenaAscensionAndTristanDaCunha:
      return "Saint Helena, Ascension and Tristan da Cunha";
    case Country.Slovenia:
      return "Slovenia";
    case Country.SvalbardAndJanMayen:
      return "Svalbard and Jan Mayen";
    case Country.Slovakia:
      return "Slovakia";
    case Country.SierraLeone:
      return "Sierra Leone";
    case Country.SanMarino:
      return "San Marino";
    case Country.Senegal:
      return "Senegal";
    case Country.Somalia:
      return "Somalia";
    case Country.Suriname:
      return "Suriname";
    case Country.SouthSudan:
      return "South Sudan";
    case Country.SaoTomeAndPrincipe:
      return "Sao Tome and Principe";
    case Country.ElSalvador:
      return "El Salvador";
    case Country.SintMaartenDutchPart:
      return "Sint Maarten (Dutch part)";
    case Country.SyrianArabRepublic:
      return "Syrian Arab Republic (the)";
    case Country.Eswatini:
      return "Eswatini";
    case Country.TurksAndCaicosIslands:
      return "Turks and Caicos Islands (the)";
    case Country.Chad:
      return "Chad";
    case Country.FrenchSouthernTerritories:
      return "French Southern Territories (the)";
    case Country.Togo:
      return "Togo";
    case Country.Thailand:
      return "Thailand";
    case Country.Tajikistan:
      return "Tajikistan";
    case Country.Tokelau:
      return "Tokelau";
    case Country.TimorLeste:
      return "Timor-Leste";
    case Country.Turkmenistan:
      return "Turkmenistan";
    case Country.Tunisia:
      return "Tunisia";
    case Country.Tonga:
      return "Tonga";
    case Country.Türkiye:
      return "Türkiye";
    case Country.TrinidadAndTobago:
      return "Trinidad and Tobago";
    case Country.Tuvalu:
      return "Tuvalu";
    case Country.TaiwanProvinceChina:
      return "Taiwan (Province of China)";
    case Country.TanzaniaUnitedRepublic:
      return "Tanzania, the United Republic of";
    case Country.Ukraine:
      return "Ukraine";
    case Country.Uganda:
      return "Uganda";
    case Country.UnitedStatesMinorOutlyingIslands:
      return "United States Minor Outlying Islands (the)";
    case Country.UnitedStatesAmerica:
      return "United States of America (the)";
    case Country.Uruguay:
      return "Uruguay";
    case Country.Uzbekistan:
      return "Uzbekistan";
    case Country.HolySee:
      return "Holy See (the)";
    case Country.SaintVincentAndGrenadines:
      return "Saint Vincent and the Grenadines";
    case Country.VenezuelaBolivarianRepublic:
      return "Venezuela (Bolivarian Republic of)";
    case Country.VirginIslandsBritish:
      return "Virgin Islands (British)";
    case Country.VirginIslandsUS:
      return "Virgin Islands (U.S.)";
    case Country.VietNam:
      return "Viet Nam";
    case Country.Vanuatu:
      return "Vanuatu";
    case Country.WallisAndFutuna:
      return "Wallis and Futuna";
    case Country.Samoa:
      return "Samoa";
    case Country.Yemen:
      return "Yemen";
    case Country.Mayotte:
      return "Mayotte";
    case Country.SouthAfrica:
      return "South Africa";
    case Country.Zambia:
      return "Zambia";
    case Country.Zimbabwe:
      return "Zimbabwe";
    case Country.Kosovo:
      return "Kosovo";
    case Country.UnitedKingdomNorthernIreland:
      return "United Kingdom (Northern Ireland)";
  }
}
